import React, { useState } from 'react';

const FAQClient = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "Pourquoi le statut de suivi de mon envoi ne change-t-il pas ?",
      answer: "Le délai de livraison peut être prolongé en raison de facteurs tels que des intempéries, des contrôles douaniers ou des retards. Le statut de suivi de l’envoi peut également rester inchangé pendant une période prolongée lors des expéditions à l’étranger. Si votre colis n’est pas arrivé dans les 3 jours suivant la date de livraison prévue, veuillez contacter votre expéditeur ou la boutique en ligne. L’expéditeur ou la boutique en ligne pourra alors lancer une enquête pour objet perdu."
    },
    {
      question: "Quand mon colis sera-t-il livré ?",
      answer: "Une fois votre colis traité, la livraison s’effectue selon le service sélectionné par l’expéditeur. Cela prend généralement 1 à 2 jours ouvrables au maximum."
    },
    {
      question: "Comment puis-je suivre mon envoi ?",
      answer: "Parfois, plusieurs envois utilisent le même numéro de suivi. Dans ce cas, nous affichons les dix premiers résultats. Veuillez essayer d’utiliser un identifiant de colis (pieceID) ou un numéro de conteneur si disponible."
    }
  ];

  return (
    <section id="faq" className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="md:flex md:space-x-12">
          {/* Left Column: Title and Subtitle */}
          <div className="md:w-1/3 mb-12 md:mb-0">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 animate-on-scroll">
              <span className="bg-primary-custom px-2">Foire Aux Questions</span>
            </h2>
            <p className="text-gray-600 animate-on-scroll">
              Vous avez d'autres questions ? N’hésitez pas à nous <a href="/contact" className="underline">contacter</a>.
            </p>
          </div>

          {/* Right Column: FAQ Items */}
          <div className="md:w-2/3">
            <div>
              {faqItems.map((item, index) => (
                <div key={index} className="border-t border-gray-200 animate-on-scroll">
                  <button
                    className="faq-toggle w-full py-5 px-4 text-left flex justify-between items-center focus:outline-none"
                    onClick={() => toggleFAQ(index)}
                  >
                    <h3 className={`text-xl font-semibold ${activeIndex === index ? 'text-primary-custom' : ''}`}>{item.question}</h3>
                    <span className={`text-2xl transform transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`}>
                      {activeIndex === index ? '−' : '+'}
                    </span>
                  </button>
                  <div
                    className={`px-4 overflow-hidden transition-all duration-300 ease-in-out ${
                      activeIndex === index ? 'max-h-96 opacity-100 pb-5' : 'max-h-0 opacity-0 pb-0'
                    }`}
                  >
                    <p className="text-gray-600">{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQClient;
